import {
  AlertCircle,
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowDownUp,
  ArrowRight,
  ArrowRightCircle,
  ArrowUp,
  ArrowUpCircle,
  ArrowUpDown,
  Ban,
  Banknote,
  BarChart,
  BarChart2,
  Barrel,
  Bike,
  Bold,
  Building,
  Building2,
  Calculator,
  Calendar,
  Car,
  Carrot,
  Check,
  CheckCircle,
  ChefHat,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsDownUp,
  ChevronsLeft,
  ChevronsRight,
  ChevronsUpDown,
  ChevronUp,
  Circle,
  CircleMinus,
  CirclePoundSterling,
  CircleUser,
  ClipboardList,
  Copy,
  Clock,
  Cloud,
  Coffee,
  Container,
  CookingPot,
  Dot,
  Download,
  Edit2Icon,
  ExternalLink,
  Factory,
  FileChartColumn,
  FileCode,
  FileImage,
  FileSpreadsheet,
  FileStack,
  Flame,
  Forklift,
  Fuel,
  GripVertical,
  HelpCircle,
  Home,
  Hourglass,
  Import,
  Info,
  Italic,
  LayoutDashboard,
  Leaf,
  LifeBuoy,
  LineChart,
  Link2,
  List,
  ListChecks,
  ListFilter,
  Loader,
  Loader2,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Menu,
  Microwave,
  Minus,
  Moon,
  MoreHorizontal,
  Network,
  Package,
  PackageSearch,
  PanelLeft,
  Paperclip,
  Pencil,
  PieChart,
  Pizza,
  Plane,
  PlugZap,
  PlusCircle,
  PlusIcon,
  Puzzle,
  Recycle,
  RefreshCcw,
  Refrigerator,
  Salad,
  Scale,
  ScanSearch,
  ScrollText,
  Search,
  Send,
  Settings,
  Shield,
  Ship,
  ShoppingBag,
  ShoppingCart,
  Snowflake,
  Sparkles,
  Sprout,
  Stamp,
  Store,
  Sun,
  ScanBarcode,
  Tag,
  Tags,
  Thermometer,
  Tractor,
  TrainFront,
  Trash2,
  TrendingDown,
  TrendingUp,
  Truck,
  TruckElectric,
  Undo,
  Upload,
  User,
  Users,
  Utensils,
  Wand2,
  Warehouse,
  X,
  XCircle,
  Zap,
} from 'lucide-react';

export const Icons = {
  archive: Archive,
  ban: Ban,
  banknote: Banknote,
  bold: Bold,
  building2: Building2,
  italic: Italic,
  list: List,
  users: Users,
  arrowUpCircle: ArrowUpCircle,
  arrowRightCircle: ArrowRightCircle,
  arrowUp: ArrowUp,
  arrowUpDown: ArrowUpDown,
  arrowDown: ArrowDown,
  arrowDownUp: ArrowDownUp,
  arrowRight: ArrowRight,
  barChart: BarChart,
  barrel: Barrel,
  bike: Bike,
  building: Building,
  car: Car,
  carrot: Carrot,
  check: Check,
  checkCircle: CheckCircle,
  chefHat: ChefHat,
  circle: Circle,
  circleMinus: CircleMinus,
  container: Container,
  cookingPot: CookingPot,
  dot: Dot,
  alertCircle: AlertCircle,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronsLeft: ChevronsLeft,
  chevronRight: ChevronRight,
  chevronsRight: ChevronsRight,
  chevronsUpDown: ChevronsUpDown,
  chevronsDownUp: ChevronsDownUp,
  chevronUp: ChevronUp,
  circleUser: CircleUser,
  clipboardList: ClipboardList,
  copy: Copy,
  calendar: Calendar,
  calculator: Calculator,
  clock: Clock,
  cloud: Cloud,
  coffee: Coffee,
  barChart2: BarChart2,
  company: Building,
  dashboard: LayoutDashboard,
  download: Download,
  edit: Edit2Icon,
  ellipsis: MoreHorizontal,
  factory: Factory,
  fileStack: FileStack,
  fileSpreadsheet: FileSpreadsheet,
  fileChartColumn: FileChartColumn,
  fileCode: FileCode,
  fileImage: FileImage,
  flame: Flame,
  forklift: Forklift,
  fuel: Fuel,
  gripVertical: GripVertical,
  help: HelpCircle,
  home: Home,
  hourglass: Hourglass,
  info: Info,
  import: Import,
  lifeBuoy: LifeBuoy,
  lineChart: LineChart,
  link: Link2,
  linkExternal: ExternalLink,
  listChecks: ListChecks,
  loader: Loader,
  loader2: Loader2,
  lock: Lock,
  logOut: LogOut,
  mail: Mail,
  leaf: Leaf,
  listFilter: ListFilter,
  mapPin: MapPin,
  microwave: Microwave,
  minus: Minus,
  menu: Menu,
  moon: Moon,
  package: Package,
  panelLeft: PanelLeft,
  packageSearch: PackageSearch,
  paperClip: Paperclip,
  pizza: Pizza,
  pencil: Pencil,
  pieChart: PieChart,
  plane: Plane,
  plugZap: PlugZap,
  plus: PlusIcon,
  plusCircle: PlusCircle,
  pound: CirclePoundSterling,
  puzzle: Puzzle,
  recycle: Recycle,
  refrigerator: Refrigerator,
  salad: Salad,
  scale: Scale,
  scanSearch: ScanSearch,
  search: Search,
  scrollText: ScrollText,
  shoppingBag: ShoppingBag,
  network: Network,
  send: Send,
  settings: Settings,
  shield: Shield,
  ship: Ship,
  snowflake: Snowflake,
  sparkles: Sparkles,
  sprout: Sprout,
  stamp: Stamp,
  store: Store,
  sun: Sun,
  scanBarcode: ScanBarcode,
  tag: Tag,
  tags: Tags,
  shoppingCart: ShoppingCart,
  thermometer: Thermometer,
  trash2: Trash2,
  tractor: Tractor,
  train: TrainFront,
  trendingDown: TrendingDown,
  trendingUp: TrendingUp,
  truck: Truck,
  truckElectric: TruckElectric,
  undo: Undo,
  upload: Upload,
  user: User,
  utensils: Utensils,
  wand2: Wand2,
  warehouse: Warehouse,
  warning: AlertTriangle,
  x: X,
  xCircle: XCircle,
  zap: Zap,
  refreshCcw: RefreshCcw,
};
